function handleStandardTurning(event, page, view) {
  const windowWidth = $(window).width();
  if (page === 1) {
    $('#MainContent').css('margin-left', windowWidth > 1400 ? '-375px' : '-300px');
    $('body').removeClass('flip-book-black-bg');
  } else {
    $('#clonedPopover').hide();
    $('#MainContent').css('margin-left', 'unset');
    $('body').addClass('flip-book-black-bg');
  }
}

function handleStandardTurned(event, page, view) {
  let newUrl = '';
  $('.main-nav .menu-item div').removeClass('active');
  if (page === 1) {
    $('.main-nav .menu-item div[data-id="page-home-link"]').addClass('active');
    newUrl = '/';
  }
  if (page === 2 || page === 3) {
    $('.main-nav .menu-item div[data-id="page-lookbook-link"]').addClass('active');
    newUrl = '/pages/lookbook';
  }
  if (page === 4) {
    $('.main-nav .menu-item div[data-id="page-mot-link"]').addClass('active');
    newUrl = '/pages/mot';
  }
  if (page === 6) {
    $('.main-nav .menu-item div[data-id="page-campaign-link"]').addClass('active');
    newUrl = '/pages/campaign';
  }
  if (newUrl) {
    history.pushState({ page: page }, '', newUrl);
  }

  if ($('.masonry-grid').length) {
    var $container = $('.masonry-grid').masonry({
      itemSelector: 'img',
      columnWidth: '.grid-sizer',
      gutter: 20,
      percentPosition: true
    });

    $container.imagesLoaded().progress(function () {
      $container.masonry('layout');
    });
  }
}

function getStandardFlipbookEvents() {
  return {
    turning: handleStandardTurning,
    turned: handleStandardTurned,
  };
}

function initializeFlipbookSize() {
  const windowWidth = $(window).width();
  const windowHeight = $(window).height();
  let flipbookWidth, flipbookHeight;

  if (windowWidth >= 1023 && windowWidth <= 1300) {
    flipbookWidth = 1072;
    flipbookHeight = 660;
  } else if (windowWidth >= 1300 && windowWidth <= 1400) {
    flipbookWidth = 1272;
    flipbookHeight = 780;
  } else if (windowWidth > 1400) {
    flipbookWidth = 1472;
    flipbookHeight = 880;
  }

  if (windowHeight < flipbookHeight) {
    const aspectRatio = flipbookWidth / flipbookHeight;
    flipbookHeight = windowHeight - 100;
    flipbookWidth = flipbookHeight * aspectRatio;
  }

  return { flipbookWidth, flipbookHeight };
}

function destroyFlipbook(selector) {
  if ($(selector).data('turn')) {
    $(selector).turn('destroy');
    $(selector).hide();
  }
}

let savedCoverDimensions = null;

function resizeCoverPage() {
  const windowWidth = $(window).width();
  const windowHeight = $(window).height();

  if (windowWidth <= 1023) {
    const aspectRatio = 756 / 900;
    const coverPageWidth = windowWidth - 20;
    const coverPageHeight = windowHeight - 100;

    if ((coverPageWidth / coverPageHeight) > aspectRatio) {
      const newWidth = coverPageHeight * aspectRatio;
      const newHeight = coverPageHeight;

      savedCoverDimensions = { width: newWidth, height: newHeight };

      $('#mobile-layout .mag-cover, #mobile-layout .homepage-cover').css({
        width: newWidth,
        height: newHeight
      });
    } else {
      $('#mobile-layout .mag-cover, #mobile-layout .homepage-cover').css({
        width: coverPageWidth,
        height: coverPageWidth / aspectRatio
      });
    }
  }
}

function calculatePortraitSizeFromLandscape() {
  const windowWidth = $(window).width();
  const windowHeight = $(window).height();
  const aspectRatio = 756 / 900;

  const coverPageWidth = windowHeight - 20;
  const coverPageHeight = windowWidth - 100;

  if ((coverPageWidth / coverPageHeight) > aspectRatio) {
    return {
      width: coverPageHeight * aspectRatio,
      height: coverPageHeight
    };
  } else {
    return {
      width: coverPageWidth,
      height: coverPageWidth / aspectRatio
    };
  }
}

function applySavedDimensions() {
  if (savedCoverDimensions) {
    $('#mobile-layout .mag-cover, #mobile-layout .homepage-cover').css({
      width: savedCoverDimensions.width,
      height: savedCoverDimensions.height
    });
  }
}

function showFlipbookWhenReady(selector) {
  requestAnimationFrame(function checkFlipbook() {
    if ($(selector).turn('page') > 0) {
      $(selector).css({
        visibility: 'visible',
        opacity: '1',
      });
    } else {
      requestAnimationFrame(checkFlipbook);
    }
  });
}

function setupFlipbookEvents(selector) {
  $(selector)[0].addEventListener('mousedown', function (e) {
    const $t = $(e.target);

    if ($t.is('.inner-page, .clip, .inner-gradient, .outer-gradient') ||
        $t.closest('.inner-page').length > 0) {

      const innerPage = $t.is('.inner-page') ? e.target : $t.closest('.inner-page')[0];
      if (!innerPage) return;

      const rect = innerPage.getBoundingClientRect();
      const fromBottom = rect.bottom - e.clientY;
      const fromLeft = e.clientX - rect.left;
      const fromRight = rect.right - e.clientX;
      const hoverAreaSize = 50;

      const inBottomCorner = (
        fromBottom <= hoverAreaSize &&
        (fromLeft <= hoverAreaSize || fromRight <= hoverAreaSize)
      );

      if (!inBottomCorner) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return;
      }
    }
  }, true);

  $(selector).on('start', function (event, pageObject, corner) {
    const allowedCorners = ['br', 'bl'];
    if (!allowedCorners.includes(corner)) {
      event.preventDefault();
      return;
    }
    $(selector).removeClass('grabbing notgrab').addClass(corner ? 'grab' : 'notgrab');
  });

  $(selector).on('mousedown touchstart', function () {
    if ($(selector).hasClass('grab')) {
      $(selector).removeClass('grab notgrab').addClass('grabbing');
    }
  });

  $(selector).on('mouseup touchend end', function () {
    $(selector).removeClass('grabbing grab').addClass('notgrab');
  });

  $(selector).on('touchmove', function (event) {
    event.preventDefault();
  });

  $(selector).on('turning', function () {
    const audio = $('#flipSound')[0];
    if (audio) {
      audio.play().catch(() => console.log('Autoplay blocked.'));
    }
  });
}

function fixPageBleedThrough(selector) {
  $(selector).on('turned', function () {
    $(selector).find('.page-wrapper').each(function () {
      const isVisible = $(this).css('display') !== 'none';
      if (isVisible) {
        $(this).css('overflow', 'hidden');
      }
    });
  });
}

function getInitialPageByUrlPath() {
  const windowWidth = $(window).width();
  const urlPath = window.location.pathname;

  function setFlipbookPosition() {
    $('#clonedPopover').hide();
    $('#MainContent').css('margin-left', 'unset');
    $('body').addClass('flip-book-black-bg');
  }

  if (urlPath === '/pages/lookbook') {
    $('.main-nav .menu-item div[data-id="page-lookbook-link"]').addClass('active');
    setFlipbookPosition();
    return 2;
  } else if (urlPath === '/pages/mot') {
    $('.main-nav .menu-item div[data-id="page-mot-link"]').addClass('active');
    setFlipbookPosition();
    return 4;
  } else if (urlPath === '/pages/campaign') {
    $('.main-nav .menu-item div[data-id="page-campaign-link"]').addClass('active');
    setFlipbookPosition();
    return 6;
  } else {
    // Home page
    $('.main-nav .menu-item div[data-id="page-home-link"]').addClass('active');
    $('#MainContent').css('margin-left', windowWidth > 1400 ? '-375px' : '-300px');
    $('body').removeClass('flip-book-black-bg');
    return 1;
  }
}

function initStandardFlipbook() {
  const flipbookSelector = '#flipbook';
  const $flipbook = $(flipbookSelector);

  if ($flipbook.length === 0) return;

  if ($(window).width() <= 1023 && $flipbook.data('turn')) {
    destroyFlipbook(flipbookSelector);
    return;
  }

  const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();

  $flipbook.turn({
    width: flipbookWidth,
    height: flipbookHeight,
    autoCenter: false,
    gradients: true,
    acceleration: true,
    elevation: 50,
    duration: 1000,
    smartFlip: true,
    hover: true,
    autoScaleContent: true,
    turnCorners: 'bl,br',
    page: getInitialPageByUrlPath(),
    when: getStandardFlipbookEvents()
  });

  setupFlipbookEvents(flipbookSelector);
  fixPageBleedThrough(flipbookSelector);
  showFlipbookWhenReady(flipbookSelector);
}

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  $('.page-link')
    .filter(`[data-page="${parseInt(urlParams.get(param)) || 1}"]`)
    .addClass('active');
  return parseInt(urlParams.get(param)) || 1;
}

function getPhysicalPage(paginationNumber) {
  return (paginationNumber - 1) * 2 + 2;
}

function initShopFlipbook() {
  const flipbookSelector = '#shop-flipbook';
  const $flipbook = $(flipbookSelector);

  if ($flipbook.length === 0) return;
  if ($(window).width() <= 1023 && $flipbook.data('turn')) {
    destroyFlipbook(flipbookSelector);
    return;
  }

  // Sort must be applied before Liquid renders — do a real redirect if missing
  const url = new URL(window.location);
  if (!url.searchParams.get('sort_by')) {
    url.searchParams.set('sort_by', 'created-descending');
    window.location.replace(url.toString());
    return;
  }

  const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();
  const queryPage = getQueryParam('page');
  const initialPage = queryPage === 1 ? 1 : getPhysicalPage(queryPage);

  $flipbook.turn({
    width: flipbookWidth,
    height: flipbookHeight,
    autoCenter: false,
    gradients: true,
    acceleration: true,
    elevation: 50,
    duration: 1000,
    smartFlip: true,
    hover: true,
    autoScaleContent: true,
    page: initialPage,
    turnCorners: 'bl,br'
  });

  // Prevent landing on or turning back to the dummy cover page
  $flipbook.on('turning', function (event, page) {
    if (page === 1) event.preventDefault();
  });

  // Skip dummy cover on initial load
  if (initialPage === 1) {
    setTimeout(() => $flipbook.turn('page', 2), 300);
  }

  $('.page-link').on('click', function (e) {
    e.preventDefault();
    const targetPage = parseInt($(this).data('page'));
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('page', targetPage);
    if (!newUrl.searchParams.get('sort_by')) {
      newUrl.searchParams.set('sort_by', 'created-descending');
    }
    window.history.pushState({}, '', newUrl.toString());
    $flipbook.turn('page', getPhysicalPage(targetPage));
    $('.page-link').removeClass('active').filter(`[data-page="${targetPage}"]`).addClass('active');
  });

  setupFlipbookEvents(flipbookSelector);
  fixPageBleedThrough(flipbookSelector);
  showFlipbookWhenReady(flipbookSelector);
}

function initProductFlipbook() {
  const flipbookSelector = '#product-flipbook';
  const $flipbook = $(flipbookSelector);

  if ($flipbook.length === 0) return;

  if ($(window).width() <= 1023 && $flipbook.data('turn')) {
    destroyFlipbook(flipbookSelector);
    return;
  }

  const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();

  $flipbook.turn({
    width: flipbookWidth,
    height: flipbookHeight,
    autoCenter: false,
    gradients: true,
    acceleration: true,
    elevation: 50,
    duration: 1000,
    smartFlip: true,
    autoScaleContent: true,
    page: 1,
  });

  $flipbook.on('turning', function (event, page) {
    if (page === 1) {
      event.preventDefault();
    }
  });

  setTimeout(() => {
    $flipbook.turn('page', 2);
  }, 300);

  $flipbook.on('turned', function (event, page) {
    if (page === 1) {
      $flipbook.turn('page', 2);
    }
  });

  setupFlipbookEvents(flipbookSelector);
  showFlipbookWhenReady(flipbookSelector);
}

$(document).ready(function () {
  // Intercept shop/collections links and append sort_by
  $('a[href*="/collections"]').on('click', function(e) {
    const href = $(this).attr('href');
    if (!href) return;
    
    // Skip if sort_by already present
    if (href.includes('sort_by')) return;
    
    e.preventDefault();
    const url = new URL(href, window.location.origin);
    url.searchParams.set('sort_by', 'created-descending');
    window.location.href = url.toString();
  });

  if ($(window).width() >= 1023) {
    initStandardFlipbook();
    initShopFlipbook();
    initProductFlipbook();
  }

  function handleResize() {
    if ($(window).width() <= 1023 && $(window).width() < $(window).height()) {
      resizeCoverPage();
    } else if ($(window).width() <= 1023 && $(window).width() > $(window).height()) {
      if (!savedCoverDimensions) {
        savedCoverDimensions = calculatePortraitSizeFromLandscape();
      }
      applySavedDimensions();
    } else {
      if ($('.page-wrapper').length < 1) {
        initStandardFlipbook();
        initShopFlipbook();
        initProductFlipbook();
      }
    }
  }

  if ($(window).width() <= 1023 && $(window).width() > $(window).height()) {
    savedCoverDimensions = calculatePortraitSizeFromLandscape();
    applySavedDimensions();
  } else if ($(window).width() <= 1023) {
    resizeCoverPage();
  }

  function resizeFlipbook() {
    const { flipbookWidth, flipbookHeight } = initializeFlipbookSize();
    $('.flipbook-wrapper').turn('size', flipbookWidth, flipbookHeight);
  }

  $(window).on('resize', function () {
    handleResize();
    if ($(window).width() > 1023) {
      resizeFlipbook();
    }
  });
});